var myapp_get_color = {
	primary_50: '#ccbfdf',
	primary_100: '#beaed7',
	primary_200: '#b19dce',
	primary_300: '#a38cc6',
	primary_400: '#967bbd',
	primary_500: '#886ab5',
	primary_600: '#7a59ad',
	primary_700: '#6e4e9e',
	primary_800: '#62468d',
	primary_900: '#563d7c',
	success_50: '#7aece0',
	success_100: '#63e9db',
	success_200: '#4de5d5',
	success_300: '#37e2d0',
	success_400: '#21dfcb',
	success_500: '#1dc9b7',
	success_600: '#1ab3a3',
	success_700: '#179c8e',
	success_800: '#13867a',
	success_900: '#107066',
	info_50: '#9acffa',
	info_100: '#82c4f8',
	info_200: '#6ab8f7',
	info_300: '#51adf6',
	info_400: '#39a1f4',
	info_500: '#2196F3',
	info_600: '#0d8aee',
	info_700: '#0c7cd5',
	info_800: '#0a6ebd',
	info_900: '#0960a5',
	warning_50: '#ffebc1',
	warning_100: '#ffe3a7',
	warning_200: '#ffdb8e',
	warning_300: '#ffd274',
	warning_400: '#ffca5b',
	warning_500: '#ffc241',
	warning_600: '#ffba28',
	warning_700: '#ffb20e',
	warning_800: '#f4a500',
	warning_900: '#da9400',
	danger_50: '#feb7d9',
	danger_100: '#fe9ecb',
	danger_200: '#fe85be',
	danger_300: '#fe6bb0',
	danger_400: '#fd52a3',
	danger_500: '#fd3995',
	danger_600: '#fd2087',
	danger_700: '#fc077a',
	danger_800: '#e7026e',
	danger_900: '#ce0262',
	fusion_50: '#909090',
	fusion_100: '#838383',
	fusion_200: '#767676',
	fusion_300: '#dimgray',
	fusion_400: '#5d5d5d',
	fusion_500: '#505050',
	fusion_600: '#434343',
	fusion_700: '#363636',
	fusion_800: '#2a2a2a',
	fusion_900: '#1d1d1d'
}

module.exports = myapp_get_color;
